export default "__VITE_ASSET___Bf8l3XX__"